module.exports = __webpack_public_path__ + "img/file-approval-survey-2.f69d8d53.png";